import { render, staticRenderFns } from "./InvitesNotFound.vue?vue&type=template&id=6aad8e94&scoped=true&"
import script from "./InvitesNotFound.vue?vue&type=script&lang=js&"
export * from "./InvitesNotFound.vue?vue&type=script&lang=js&"
import style0 from "./InvitesNotFound.vue?vue&type=style&index=0&id=6aad8e94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aad8e94",
  null
  
)

export default component.exports